// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "admin" + "." + "8cffbc2d" + ".chunk.css";
};